export var changeTrackListExpanded = function (data) { return function (dispatch) {
    dispatch({
        type: 'CHANGE_EXPANDED_TRACK_LIST',
        payload: data,
    });
}; };



//////////////////
// WEBPACK FOOTER
// ./src/store/actions/trackList.actions.ts
// module id = 1432
// module chunks = 81